import { render } from "./PlayerProfileEditDescription.vue?vue&type=template&id=27dd8bda"
import script from "./PlayerProfileEditDescription.vue?vue&type=script&lang=js"
export * from "./PlayerProfileEditDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/windowOverlay/PlayerProfileEditDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27dd8bda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27dd8bda', __exports__)) {
    api.reload('27dd8bda', __exports__)
  }
  
  module.hot.accept("./PlayerProfileEditDescription.vue?vue&type=template&id=27dd8bda", () => {
    api.rerender('27dd8bda', render)
  })

}


export default __exports__